import {ChangeDetectorRef, Component, OnInit, ViewChild, ViewEncapsulation} from '@angular/core';
import {FormBuilder, FormGroup, NgForm, Validators} from '@angular/forms';
import {ActivatedRoute, Router} from '@angular/router';
import {TranslateService} from '@ngx-translate/core';
import {FuseAlertType, fuseAnimations} from 'fuseui';
import {AuthStingService} from '../auth.service';
import {ToastrService} from 'ngx-toastr';

@Component({
    selector: 'auth-sign-in',
    templateUrl: './sign-in.component.html',
    styleUrls: ['./sign-in.styles.scss'],
    encapsulation: ViewEncapsulation.None,
    animations: fuseAnimations,
    standalone: false
})
export class AuthSignInComponent implements OnInit {
    @ViewChild('signInNgForm') signInNgForm!: NgForm;

    alert: { type: FuseAlertType; message: string; link: boolean } = {
        type: 'success',
        message: '',
        link: false,
    };

    signInForm!: FormGroup;
    showAlert = false;
    token: any;
    cantLogin = false;


    constructor(
        private _authService: AuthStingService,
        private _formBuilder: FormBuilder,
        private route: ActivatedRoute,
        private _router: Router,
        private translateService: TranslateService,
        private _changeDetectorRef: ChangeDetectorRef,
        private _toastr: ToastrService,
    ) {

        this.signInForm = this._formBuilder.group({
            email: ['', [Validators.required, Validators.email]],
            password: ['', Validators.required],
            rememberMe: [''],
        });
    }

    async ngOnInit(): Promise<void> {
        await this.translateService.get('key').toPromise().then(); // Wait for translate file to load.

        this.token = this.route.snapshot.paramMap.get('token');
        this._changeDetectorRef.detectChanges();

        if (this.token) {
            this.tokenLogin();
        }

        setTimeout(() => {
            this.cantLogin = true;
            this._changeDetectorRef.detectChanges();
        }, 5000)

    }

    tokenLogin() {
        this._authService.signInWithToken(this.token).subscribe(value => {

            this._router.navigateByUrl(value?.url).catch(reason => {
                console.error(reason);
                this._router.navigateByUrl('/dashboard');
                this._changeDetectorRef.detectChanges();
            });
            this._changeDetectorRef.detectChanges();
        }, error => {
            this._toastr.error(error?.error?.message, 'Nastala chyba při průběžném ukládání!');
            this.token = undefined;
            this._changeDetectorRef.detectChanges();
        });
    }

    signIn(): void {

        if (this.signInForm.invalid) {
            return;
        }

        const email = this.signInForm.get('email')?.value;
        this.signInForm.disable();
        this.showAlert = false;
        this._authService.tryToSignIn(this.signInForm.value).subscribe(value => {


            if (value?.accessToken) {
                this._router.navigateByUrl(value?.url).catch(reason => {
                    console.error(reason);
                    this._router.navigateByUrl('/dashboard');
                    this._changeDetectorRef.detectChanges();
                });
                this._changeDetectorRef.detectChanges();
            } else if (value?.hash) {
                console.log('transport', value.transport);
                const transport = value?.transport || 'mail';
                this._router.navigateByUrl(`/two-factor?hash=${encodeURIComponent(value.hash)}&transport=${transport}`);
                this._changeDetectorRef.detectChanges();
            }
        }, (error: any) => {
            console.log('error: ', error);
            this.signInForm.enable();
            this.signInNgForm.resetForm();
            this.signInForm.get('email')?.setValue(email);

            if (error?.error) {
                this.alert = {
                    type: 'error',
                    message: this.translateService.instant(error?.error?.message),
                    link: false,
                };

                if (error?.error?.message === 'section.be-messages.user_is_not_verification' || error?.error?.message === 'Uživatel není verifikovaný') {
                    this.alert = {
                        type: 'error',
                        message: this.translateService.instant('auth.signup.verification_error'),
                        link: true,
                    };
                }
            } else {
                this.alert = {
                    type: 'error',
                    message: this.translateService.instant('auth.signup.error'),
                    link: false,
                };
            }

            this.showAlert = true;
            this._changeDetectorRef.detectChanges();

        });
    }
}
